import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Select } from 'chakra-react-select';
import { Box } from '@chakra-ui/react';
import { useGetRules } from '../queries';
import { dropDownFormStyle } from 'components/forms/new/formStyles';
import { customSelectStyles } from '../constants';

const RulesDropdown = ({ dialPlanId, currentRuleId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { darkMode } = useSelector((state) => state.settings);
    const { data: rules, isLoading } = useGetRules(dialPlanId);

    const handleChange = (option) => {
        if (option?.value) {
            navigate(
                `/dial-plans/${dialPlanId}/rules/${option.value}${location.search}`,
            );
        }
    };

    if (isLoading) return <span>Loading...</span>;

    const options =
        rules?.map((rule) => ({
            label: rule.name,
            value: rule.id,
        })) || [];

    const selectedOption = options.find((opt) => opt.value === currentRuleId);

    const customStyles = dropDownFormStyle(darkMode);

    return (
        <Box minWidth="250px" display="inline-block">
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                menuPortalTarget={document.body}
                useBasicStyles
                chakraStyles={customSelectStyles(customStyles, darkMode)}
                isSearchable
                placeholder="Select Rule"
                classNamePrefix="chakra-react-select"
            />
        </Box>
    );
};

export default RulesDropdown;
